import React from 'react';
// IMPORTAR LA IMAGEN
import Imagen4 from '../assets/imagen_4.png'; // <<== AJUSTA ESTA RUTA SEGÚN DÓNDE ESTÉ TU IMAGEN

// === SVGs para la sección de Misión, Visión y Valores ===
// Misión (Libro Abierto)
const BookOpenIcon = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className={className}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M12 10.5v6m0 0l-3-3m3 3l3-3m-9 3h8.25M7.5 10.5h2m7.5 0h2.25M12 12a7.5 7.5 0 001.5-3.375M12 12a7.5 7.5 0 01-1.5-3.375M12 12v3.75m3-6.442l-2.492-.801 1.488 4.298-2.492.801-1.488-4.298z" />
  </svg>
);

// Visión (Globo)
const GlobeAltIcon = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className={className}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M12 21.75c-2.485 0-4.5-1.99-4.5-4.444A4.5 4.5 0 0112 12c2.485 0 4.5 1.99 4.5 4.444 0 2.454-2.015 4.444-4.5 4.444z" />
    <path strokeLinecap="round" strokeLinejoin="round" d="M12 21.75v-9.75M3 11.25h18" />
    <path strokeLinecap="round" strokeLinejoin="round" d="M12 21.75c-2.485 0-4.5-1.99-4.5-4.444A4.5 4.5 0 0112 12c2.485 0 4.5 1.99 4.5 4.444 0 2.454-2.015 4.444-4.5 4.444z" />
  </svg>
);

// Valores (Escudo/Seguridad)
const ShieldCheckIcon = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className={className}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
  </svg>
);

// === SVG para la sección Por qué Elegirnos (Check) ===
const CheckCircleIcon = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className={className}>
    <path fillRule="evenodd" d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zm13.36-1.814a.75.75 0 00-1.06-1.06l-4.25 4.25-1.75-1.75a.75.75 0 10-1.06 1.06l2.25 2.25a.75.75 0 001.06 0l4.75-4.75z" clipRule="evenodd" />
  </svg>
);

// ELIMINAMOS el SVG del Birrete ya que usaremos una imagen PNG real.


export default function Nosotros() {
  return (
    // 'pt-24' para espacio debajo del nav (asumiendo un nav fijo)
    <div className="pt-24 bg-white min-h-screen"> 
      
      {/* 🌟 Hero Section: Sobre Nosotros */}
      <section className="relative overflow-hidden bg-gradient-to-br from-[#FFF9C3] to-white border-b-4 border-[#fee017]/50 shadow-inner">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 sm:py-28 lg:py-36">
          <div className="grid lg:grid-cols-2 items-center gap-12">
            <div className="max-w-xl lg:max-w-none">
              <span className="text-sm font-semibold uppercase tracking-wider text-[#fee017] bg-gray-900 px-3 py-1 rounded-full inline-block mb-3 shadow-lg">
                Nuestra Historia
              </span>
              <h1 className="text-5xl sm:text-6xl lg:text-7xl font-extrabold tracking-tight text-gray-900 leading-tight">
                Sobre Nosotros
              </h1>
              <p className="mt-6 text-lg sm:text-xl text-gray-700 max-w-2xl leading-relaxed">
                Somos un equipo de especialistas dedicados a acompañar estudiantes e investigadores en la consecución de sus objetivos académicos con ética y excelencia.
              </p>
              <div className="mt-8 flex gap-4">
                {/* Botón CTA con estilo primario */}
                <a
                  href="#por-que-elegirnos"
                  className="px-6 py-3 border border-transparent text-base font-medium rounded-xl shadow-lg text-white bg-gray-900 hover:bg-gray-700 transition duration-300 transform hover:scale-[1.02]"
                >
                  Conoce Nuestros Pilares
                </a>
              </div>
            </div>

            {/* IMAGEN: Reemplazamos el SVG por la etiqueta <img> con estilos */}
            <div className="hidden lg:block relative">
              <div className="p-4 border-8 border-gray-100 rounded-3xl shadow-[0_35px_60px_-15px_rgba(0,0,0,0.3)] transform hover:rotate-1 transition-transform duration-500 ease-in-out">
                <img 
                  src={Imagen4} // Usamos la variable importada
                  alt="Equipo de consultoría académica" 
                  className="w-full h-auto rounded-xl object-cover" 
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      ---

      {/* 🚀 Misión, Visión y Valores (con Iconos SVG) */}
      <section className="py-20 lg:py-28 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-4xl sm:text-5xl font-extrabold text-gray-900 text-center mb-16">
            Nuestros Pilares
          </h2>
          <div className="grid md:grid-cols-3 gap-10">
            {/* Misión */}
            <div className="space-y-4 p-6 border border-gray-100 rounded-xl shadow-md hover:shadow-xl transition duration-300">
              <div className="w-14 h-14 rounded-full bg-[#fee017] text-gray-900 flex items-center justify-center font-black text-2xl shadow-inner">
                <BookOpenIcon className="w-8 h-8 stroke-2" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900">Misión</h3>
              <p className="text-gray-600 leading-relaxed">
                Proporcionar asesoría académica especializada, personalizada y de calidad para que estudiantes de pregrado y posgrado logren sus objetivos de investigación y tesis.
              </p>
            </div>

            {/* Visión */}
            <div className="space-y-4 p-6 border border-gray-100 rounded-xl shadow-md hover:shadow-xl transition duration-300">
              <div className="w-14 h-14 rounded-full bg-[#fee017] text-gray-900 flex items-center justify-center font-black text-2xl shadow-inner">
                <GlobeAltIcon className="w-8 h-8 stroke-2" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900">Visión</h3>
              <p className="text-gray-600 leading-relaxed">
                Ser el socio académico de confianza para estudiantes e investigadores en Latinoamérica, garantizando excelencia, ética y cumplimiento en cada proyecto.
              </p>
            </div>

            {/* Valores */}
            <div className="space-y-4 p-6 border border-gray-100 rounded-xl shadow-md hover:shadow-xl transition duration-300">
              <div className="w-14 h-14 rounded-full bg-[#fee017] text-gray-900 flex items-center justify-center font-black text-2xl shadow-inner">
                <ShieldCheckIcon className="w-8 h-8 stroke-2" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900">Valores</h3>
              <p className="text-gray-600 leading-relaxed">
                Integridad, excelencia académica, compromiso con resultados, respeto, transparencia y dedicación al acompañamiento personalizado.
              </p>
            </div>
          </div>
        </div>
      </section>

      ---

      {/* 🏆 Por qué elegirnos (con Iconos Check SVG) */}
      <section id="por-que-elegirnos" className="py-20 lg:py-28 bg-gradient-to-b from-[#FFF9C3]/50 to-transparent border-t-2 border-b-2 border-[#fee017]/30">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-4xl sm:text-5xl font-extrabold text-gray-900 text-center">¿Por qué elegirnos?</h2>
            
            <div className="mt-16 grid sm:grid-cols-2 gap-x-8 gap-y-10">
              {[
                {
                  title: 'Experiencia probada',
                  desc: 'Más de 200 tesis entregadas con 4.9/5 de satisfacción. ¡Tu éxito es nuestra prioridad!',
                  icon: CheckCircleIcon,
                },
                {
                  title: 'Equipo especializado',
                  desc: 'Profesionales con maestría en diversas disciplinas y metodología de investigación comprobada.',
                  icon: CheckCircleIcon,
                },
                {
                  title: 'Acompañamiento personalizado',
                  desc: 'Asignamos un especialista a tu proyecto desde el inicio hasta la presentación o sustentación.',
                  icon: CheckCircleIcon,
                },
                {
                  title: 'Cumplimiento garantizado',
                  desc: 'Respuesta en menos de 4h y cumplimiento estricto de los plazos acordados.',
                  icon: CheckCircleIcon,
                },
                {
                  title: 'Garantía antiplagio',
                  desc: 'Reporte Turnitin incluido en todos nuestros servicios para asegurar la originalidad.',
                  icon: CheckCircleIcon,
                },
                {
                  title: 'Atención 24/7',
                  desc: 'Soporte por WhatsApp disponible todos los días de la semana para resolver tus dudas rápidamente.',
                  icon: CheckCircleIcon,
                }
              ].map((item, i) => (
                <div key={i} className="flex gap-4">
                  <div className="flex-shrink-0">
                    <div className="flex items-center justify-center h-12 w-12 rounded-full bg-gray-900 text-[#fee017] font-black text-sm shadow-xl">
                      <item.icon className="w-6 h-6" />
                    </div>
                  </div>
                  <div>
                    <h4 className="text-xl font-bold text-gray-900">{item.title}</h4>
                    <p className="mt-1 text-gray-600 leading-relaxed">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      ---

      {/* 🗣️ Testimonios (Diseño tipo Tarjeta) */}
      <section className="py-20 lg:py-28 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-4xl sm:text-5xl font-extrabold text-gray-900 text-center">Lo que dicen nuestros clientes</h2>
          <div className="mt-16 grid md:grid-cols-3 gap-8">
            {[
              {
                text: 'Excelente servicio. Mi tesis quedó impecable y aprobé en la defensa con honores. Recomendado al 100%.',
                author: 'María G., Estudiante de Maestría',
                rating: 5
              },
              {
                text: 'El acompañamiento fue personalizado, paciente y me ayudó a entender toda la metodología de mi proyecto. ¡Muy profesionales!',
                author: 'Juan P., Estudiante de Pregrado',
                rating: 5
              },
              {
                text: 'Cumplieron exactamente en los plazos establecidos y la calidad del trabajo fue excepcional. Definitivamente volvería a contactarlos.',
                author: 'Andrea L., Doctoranda',
                rating: 5
              }
            ].map((item, i) => (
              <div key={i} className="bg-[#FFF9C3]/40 border-4 border-[#fee017]/50 rounded-2xl p-8 shadow-xl transform hover:shadow-2xl hover:-translate-y-1 transition duration-300">
                <div className="flex gap-0.5 mb-4 text-xl">
                  {[...Array(item.rating)].map((_, j) => (
                    <span key={j} className="text-[#facc15]">⭐</span>
                  ))}
                </div>
                <p className="text-lg text-gray-700 mb-6 italic leading-relaxed">"{item.text}"</p>
                <div className="border-t border-[#fee017]/70 pt-4">
                  <p className="text-base font-bold text-gray-900">{item.author}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      ---

      {/* 📞 CTA Final (Call to Action con Diseño Atractivo) */}
      <section className="py-16 sm:py-20 lg:py-24 text-center bg-gray-900">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl sm:text-4xl font-black text-white">¿Listo para comenzar tu proyecto?</h2>
          <p className="mt-4 text-lg text-gray-300 max-w-2xl mx-auto">
            Contáctanos hoy y recibe una cotización personalizada y sin compromiso en menos de 4 horas.
          </p>
          <a
            href="https://wa.me/+51983318651?text=Hola, quisiera información sobre vuestros servicios"
            target="_blank"
            rel="noreferrer"
            className="inline-flex items-center justify-center gap-2 px-8 py-4 mt-8 bg-[#fee017] text-gray-900 font-extrabold text-lg rounded-xl hover:bg-[#FFE55C] transition duration-300 shadow-2xl hover:shadow-3xl transform hover:scale-[1.05]"
          >
            <svg className="w-6 h-6" viewBox="0 0 24 24" fill="currentColor"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.297-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.626.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.263c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.890-5.335 11.893-11.893A11.821 11.821 0 0020.885 3.485"/></svg>
            Chatear por WhatsApp
          </a>
        </div>
      </section>
    </div>
  );
}